module.exports = __webpack_public_path__ + "static/media/pricing-icon.8348c907.svg";